<app-tables
  [headerItems]="headerItems()"
  [rows]="tableRows()"
  [selectable]="false"
  [currentActions]="rowActions"
  [isFiltersApplied]="isFiltersApplied()"
  [emptyFilterTitle]="emptyFilterTitle()"
  [emptyContentTitle]="emptyContentTitle()"
  [emptyContentDescription]="emptyContentDescription()"
  (actionTrigger)="onHandleAction($event)"></app-tables>